/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    type: NoteTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    owner?: number;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    deal?: number;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly user?: number;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Note
     */
    readonly isSend?: boolean;
}

export function NoteFromJSON(json: any): Note {
    return NoteFromJSONTyped(json, false);
}

export function NoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Note {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'type': json['type'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'deal': !exists(json, 'deal') ? undefined : json['deal'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isSend': !exists(json, 'isSend') ? undefined : json['isSend'],
    };
}

export function NoteToJSON(value?: Note | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'type': value.type,
        'owner': value.owner,
        'deal': value.deal,
    };
}

/**
* @export
* @enum {string}
*/
export enum NoteTypeEnum {
    Deal = 'deal',
    Owner = 'owner'
}


